import { getBarrios } from "../../../api/barrios";
import { getTipos } from "../../../api/tipos";
import { useGeneralAppStore } from "../../../store/generalAppStore";

const { handlerLoading } = useGeneralAppStore.getState();

export const cargaDatos = async (setTipos, setBarrios, setLoading) => {
  // setLoading(true);
  handlerLoading({ loading: true, loadName: "carga_datos" });
  await getTipos(setTipos);
  await getBarrios(setBarrios);
  // setLoading(false);
  handlerLoading({ loading: false, loadName: "carga_datos" });
};
